import { ApiGet, ApiPost } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'
import type {
  ICustomerResponse,
  IAoeRegistration,
  IAoeRegistrationResponse,
  IContactCustomerCreate
} from '@/types/CustomerTypes.ts'


export async function CustomerGet(beeNumberCustomer: number): Promise<ICustomerResponse> {
  const url = await GetOrderEntryConnectorUrl('CustomerGet')
  return ApiGet(url, { beeNumber: beeNumberCustomer })
}

export async function AccountCreate(request: IAoeRegistration): Promise<IAoeRegistrationResponse> {
  const url = await GetOrderEntryConnectorUrl('AccountCreate')
  return ApiPost(url, request)
}

export async function ContactCustomerCreate(request: IContactCustomerCreate): Promise<IAoeRegistrationResponse> {
  const url = await GetOrderEntryConnectorUrl('AccountCreate')
  return ApiPost(url, request)
}

